// @ts-check
/** Admin gift assistant chat API. Confirm is an explicit endpoint, never a chat message. */

import api from '../utils/apiClient';

const BASE = '/api/admin/assistant';

const adminAssistantService = {
  /** @returns {Promise<{enabled: boolean}>} */
  async getStatus() {
    return api.get(`${BASE}/status`);
  },

  /** @returns {Promise<{conversation_id: string|null, messages: Array<{role: string, text: string, kind: string}>, pending_action: Object|null}>} */
  async getLatest() {
    return api.get(`${BASE}/conversations/latest`);
  },

  /**
   * @param {{conversationId: string|null, message: string}} args
   * @returns {Promise<{conversation_id: string, text: string, pending_action: Object|null}>}
   */
  async chat({ conversationId, message }) {
    return api.post(`${BASE}/chat`, { conversation_id: conversationId, message });
  },

  /** @param {string} actionId */
  async confirm(actionId) {
    return api.post(`${BASE}/actions/${actionId}/confirm`);
  },

  /** @param {string} actionId */
  async cancel(actionId) {
    return api.post(`${BASE}/actions/${actionId}/cancel`);
  },
};

export default adminAssistantService;
